import React, {useEffect, useState} from 'react';
import {
    AestheticQuotes,
    Amenities,
    Footer,
    Gallery,
    Hero,
    Invitation,
    NightSkyCalendar,
    Schedule,
    VideoSection
} from "../components";
import AboutUs from "../components/AboutUs";
import GlampingDescription from "../components/GlampingDescription";
import CardsDisplay from '../components/CardsDisplay';
import VideoPlaceholder from "../components/VideoPlaceholder";

function renderBackground(heroZ: number, starZ: number, redZ: number) {
    const showHero = heroZ > starZ && heroZ > redZ;
    const showStars = starZ > heroZ && starZ > redZ;
    const showRed = redZ > heroZ && redZ > starZ;

    return <>
        {showHero ? (
            <div
                className="fixed inset-0 w-full overflow-y-hidden"
                style={{
                    backgroundImage: "url('/Portada.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: heroZ,
                    pointerEvents: 'none'
                }}
            />
        ) : showStars ? (
            <div
                className="fixed inset-0 w-full h-full"
                style={{
                    backgroundImage: "url('/images/StarrySky.jpg')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: starZ,
                    pointerEvents: 'none',
                }}
            />
        ) : showRed ? (
            <div
                className="fixed inset-0 w-full h-full"
                style={{
                    backgroundImage:
                        typeof window !== 'undefined' && window.innerWidth <= 768
                            ? "url('/images/Wine-texture.png')"
                            : "url('/images/Wine-texture-h.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    zIndex: redZ,
                    pointerEvents: 'none',
                }}
            />
        ) : (<div></div>)}
    </>;
}

const MainPage = () => {
    const [heroZ, setHeroZ] = useState<number>(-1);
    const [starZ, setStarZ] = useState<number>(-2);
    const [redZ, setRedZ] = useState<number>(-3);
    const [scrollY, setScrollY] = useState<number>(0);

    //// Update scrollY whenever the window scrolls
    useEffect(() => {
        let inThrottle = false;
        const handleScroll = () => {
            if (!inThrottle) {
                setScrollY(window.scrollY);
                inThrottle = true;
                setTimeout(() => inThrottle = false, 16); // ~60fps throttling
            }
        };
        window.addEventListener('scroll', handleScroll, {passive: true});
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const screenHeight = window.innerHeight;

        const scrollCheckpoints = [
            screenHeight * 1.2,
            screenHeight * 7.9
        ]

        if (scrollY < scrollCheckpoints[0]){
            setHeroZ(-1);
            setStarZ(-2);
            setRedZ(-3);
        }

        if (scrollY >= scrollCheckpoints[0] && scrollY < scrollCheckpoints[1]){
            setHeroZ(-2);
            setStarZ(-1);
            setRedZ(-3);
        }

        if (scrollY >= scrollCheckpoints[1]){
            setHeroZ(-3);
            setStarZ(-2);
            setRedZ(-1);
        }
    }, [scrollY]);

    return (
        <>
            <div className="overflow-hidden">
                <Hero/>
                {renderBackground(heroZ, starZ, redZ)}
                <div className="relative z-10">
                    <AestheticQuotes/>
                    <AboutUs/>
                    <VideoSection
                        videoSrc="/SaveTheDateE&E.mp4"
                        posterImage="/images/Video2Thumbnail.JPG"
                        requestFullscreenOnMobile={true}
                    >
                        <VideoPlaceholder />
                    </VideoSection>
                </div>
                <div className="relative z-0">
                    <GlampingDescription/>
                    <Gallery/>
                    <NightSkyCalendar/>
                    <Schedule/>
                    <Amenities/>
                </div>
                <div className="relative place-content-center z-10">
                    <Invitation/>
                    <CardsDisplay/>
                    <Footer/>
                </div>
            </div>
        </>
    )
};

export default MainPage;
